import { render, staticRenderFns } from "./generateReports.vue?vue&type=template&id=1a9fdd5e"
import script from "./generateReports.vue?vue&type=script&lang=js"
export * from "./generateReports.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports